import { Actions, ActionTypes } from '../actions/vpn-routing-server-configuration.action';
import {
  VpnRoutingServer,
  VpnRoutingServerConfigurationReducer,
} from '../models/vpn-routing.model';

const INITIAL_STATE: VpnRoutingServerConfigurationReducer = {
  id: 0,
  deviceId: 0,
  isVpnServerEnabled: true,
  vpn_and_routing_server: [],
  shuffledColumns: [
    { key: 'Name', field: 'name', hide: false, sort: '' },
    { key: 'Description', field: 'description', hide: false, sort: '' },
    { key: 'Server Name', field: 'server_name', hide: false, sort: '' },
    { key: 'Port', field: 'port', hide: false, sort: '' },
    {
      key: 'Server Bridge',
      field: 'server_bridge',
      hide: false,
      sort: '',
    },
    {
      key: 'Binding IP Address',
      field: 'binding_ip_address',
      minWidth: 75,
      width: 147,
      hide: false,
      sort: '',
    },
    {
      key: 'Packet Forwarding Mode',
      field: 'packet_forwarding_mode',
      hide: false,
      sort: '',
    },
    { key: 'Tunnel area', field: 'tunnel_area', hide: false, sort: '' },
    {
      key: 'Cost',
      field: 'cost',
      hide: false,
      sort: '',
    },
    { key: 'LAN Subnets', field: 'lan_subnets', hide: false, sort: '' },
    {
      key: 'LAN Interfaces',
      field: 'lan_interfaces',
      hide: false,
      sort: '',
    },
    {
      key: 'Bridge IP Address',
      field: 'bridge_ip_address',
      hide: false,
      sort: '',
    },
    {
      key: 'Bridge Members',
      field: 'bridge_members',
      hide: false,
      sort: '',
    },
    {
      key: 'Order',
      field: 'order_id',
      hide: false,
      sort: '',
    },
  ],
};

export function vpnRoutingServerConfigurationReducer(
  state = INITIAL_STATE,
  action: Actions
): VpnRoutingServerConfigurationReducer {
  switch (action.type) {
    case ActionTypes.SET_VPN_ROUTING_SERVER_CONFIGURATION:
      action.payload.vpn_and_routing_server.forEach((vpnRouting) => {
        vpnRouting.lan_interfaces = vpnRouting.lan_interfaces.toString();
      });
      return {
        ...state,
        id: action.payload.id,
        deviceId: action.payload.device_id,
        isVpnServerEnabled: action.payload.enable_vpn_and_routing_server,
        vpn_and_routing_server: action.payload.vpn_and_routing_server,
      };
    case ActionTypes.VPN_ROUTING_SERVER_COLUMN_SELECT:
      const selectedColumn = state.shuffledColumns.find(
        (column) => column.field === action.payload
      );
      if (selectedColumn) {
        selectedColumn.hide = false;
      }
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_SERVER_COLUMNS_SELECT_ALL:
      state.shuffledColumns.forEach((column) => (column.hide = false));
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_SERVER_COLUMN_DESELECT:
      const unSelectedColumn = state.shuffledColumns.find(
        (column) => column.field === action.payload
      );
      if (unSelectedColumn) {
        unSelectedColumn.hide = true;
      }
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_SERVER_DESELECT_ALL:
      state.shuffledColumns.forEach((column) => (column.hide = true));
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_SERVER_SHUFFLED_COLUMNS:
      return {
        ...state,
        shuffledColumns: [...action.payload],
      };
    case ActionTypes.ADD_VPN_ROUTING_SERVER:
      const newConfiguration = {
        ...action.payload,
        order_id: state.vpn_and_routing_server.length + 1,
      };
      return {
        ...state,
        vpn_and_routing_server: [...state.vpn_and_routing_server, newConfiguration],
      };
    case ActionTypes.EDIT_VPN_ROUTING_SERVER:
      const updatedVPNRoutingList: VpnRoutingServer[] = state.vpn_and_routing_server.map(
        (vpnRouting) =>
          vpnRouting.id === action.payload.id
            ? {
                ...action.payload,
                order_id: vpnRouting.order_id,
              }
            : vpnRouting
      );
      return {
        ...state,
        vpn_and_routing_server: updatedVPNRoutingList,
      };
    case ActionTypes.DELETE_VPN_ROUTING_SERVER:
      const ids = action.payload;
      const modifiedClassList: VpnRoutingServer[] = state.vpn_and_routing_server
        .filter((item: VpnRoutingServer) => !ids.includes(item.id))
        .map((item, index) => ({
          ...item,
          order_id: index + 1,
        }));
      return {
        ...state,
        vpn_and_routing_server: modifiedClassList,
      };
    case ActionTypes.CLEAR_VPN_ROUTING_SERVER_CONFIGURATION:
      return INITIAL_STATE;
    case ActionTypes.UPDATE_VPN_ROUTING_SERVER_COLUMN_WIDTH:
      state.shuffledColumns.forEach((column) => {
        action.payload.forEach((data) => {
          if (column.field === data.field) {
            column.width = data.width;
          }
        });
      });
      return {
        ...state,
      };

    case ActionTypes.SET_VPN_SERVER_CONFIG_STATE:
      const val = state.vpn_and_routing_server.map((vpnServer) =>
        vpnServer.id === action.payload.vpnServerData.id
          ? { ...vpnServer, is_configuration_enabled: action.payload.isEnabled }
          : vpnServer
      );
      return {
        ...state,
        vpn_and_routing_server: val,
      };

    case ActionTypes.SET_VPN_SERVER_DEVICE_LEVEL_ENABLED_STATE:
      return {
        ...state,
        isVpnServerEnabled: action.payload,
      };

    default:
      return state;
  }
}
